export default "__VITE_ASSET__hU8wpmVo__"